import { ApplicationInsights } from '@microsoft/applicationinsights-web'
import { useUserStore } from '~/stores/user'


export default defineNuxtPlugin((nuxtApp) => {
    const appInsightsEnabled = nuxtApp.$config.public.features.applicationInsights
    const appInsights = new ApplicationInsights({
        config: {
            connectionString: nuxtApp.$config.public.applicationInsightsConnectionString,
            loggingLevelConsole: 2,
            loggingLevelTelemetry: 2,
            correlationHeaderDomains: ['*.glommen-mjosen.no'],
            enableCorsCorrelation: true,
            disableAjaxTracking: false,
            disableCorrelationHeaders: false,
            disableFetchTracking: false,
            maxAjaxCallsPerView: -1,
        }
    })


    appInsights.addTelemetryInitializer(envelope => {
        const userStore = useUserStore()

        if ((envelope?.baseData?.target as String)?.includes('login-callback')) {
            return false
        }

        if (envelope?.data) {
            if (userStore.userId) {
                envelope.data.mail = userStore.userId
            }
            // TODO: include account ID (will make warnings if useRoute()/useAccountId() is used)
            // if (accountId.value) {
            //   envelope.data.accountId = accountId.value
            // }
        }

        return !!appInsightsEnabled
    })

    appInsights.loadAppInsights();

    const router = useRouter()
    router.afterEach(() => {
        appInsights.trackPageView({
            properties: {
                screenSize: `${window.screen.width}x${window.screen.height}`,
                windowSize: `${window.innerWidth}x${window.innerHeight}`,
            }
        })
    })

    return {
        provide: {
            appInsights
        }
    }
})